<template>
  <PageTemplate>
    <h6 class="element-header">
      {{$t('dashboard.dashboard_for') + piniaUserStore().currentUser?.user?.accessRightTranslated}}
    </h6>

    <nav class="dashboard_menu">
      <div class="nav nav-tabs" role="tablist">
        <router-link :to="{ name: 'dashboardPersonalInfo' }" class="nav-item nav-link" role="tab">
          {{ $t('dashboard.tabs.info') }}
        </router-link>
        <router-link :to="{ name: 'dashboardSubmittedTimeSheets' }" class="nav-item nav-link active" role="tab">
          {{ $t('dashboard.tabs.submitted_time_sheets') }}
        </router-link>
      </div>
    </nav>

    <div class="element-box mt-5">
      <h6>Suchen</h6>
      <form>
        <div class="row">
          <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <SelectVue
                placeholder="Mitarbiter"
                v-model="filterData.userId"
                :options="dropdownUsers"
                :is-clear="true"
            />
          </div>

          <div class="col-auto">
              <button type="button" class="btn btn-primary custom_search_button2" :disabled="loading" @click="getInfoData(1)">
                <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span v-if="!loading">{{ $t('general.button.search') }}</span>
                <span v-else>{{ $t('general.button.search_in_progress') }}</span>
              </button>
          </div>
        </div>
      </form>

      <div class="table-responsive overflow-auto mt-3">
        <table class="table table-striped">
          <thead>
            <tr>
              <th style="width: 25%">{{ $t('general.first_name') }}</th>
              <th style="width: 25%">{{ $t('general.last_name') }}</th>
              <th style="width: 15%" class="text-end">{{ $t('general.year') }}</th>
              <th style="width: 15%" class="text-end">{{ $t('general.month') }}</th>
              <th style="width: 20%" class="text-center">{{ $t('general.actions') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user of infoData.data" v-bind:key="user?.name">
              <td>
                <strong class="js-lists-values-employee-name">{{ user?.first_name }}</strong>
              </td>
              <td>
                <strong class="js-lists-values-employee-name">{{ user?.last_name }}</strong>
              </td>
              <td class="text-end">
                <strong class="js-lists-values-employee-name">{{ user?.year }}</strong>
              </td>
              <td class="text-end">
                <strong class="js-lists-values-employee-name">{{ user?.month }}</strong>
              </td>
              <td class="text-center">
                <router-link
                    :to="{ name: 'userForm', params: { id: user?.id } }"
                    class="btn btn-primary">
                    Übersicht
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <Pagination
          v-if="infoData?.pagination?.total_pages > 1"
          :totalPages="infoData?.pagination?.total_pages"
          :currentPage="infoData?.pagination?.current_page"
          @pagechanged="getInfoData"/>
    </div>
  </PageTemplate>
</template>

<script setup>
import dashboardHRService from '@/api/Dashboard/HR';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import { ErrorToast } from '@/components/VueToast';
import { onMounted, ref } from 'vue';
import { getUsersForHrOverviewDropdown } from '@/shared/dropdowns';
import SelectVue from '@/components/SelectVue.vue';
import { piniaUserStore } from '@/store/piniaUserStore';

const infoData = ref({});
const dropdownUsers = ref([]);
const filterData = ref({
});

async function getInfoData(page = 1, perPage = 10) {
  try {
    const { data } = await dashboardHRService.getPendingTimeManagement({...filterData.value, page, perPage});    
    infoData.value = data;

  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(() => {
  getInfoData();
  getUsersForHrOverviewDropdown(dropdownUsers);
})
</script>


<style scoped></style>
